import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const getTargetedDropOutreachCreatorsEndpoint = {
    [dropEndpointIds.GET_TARGETED_DROP_OUTREACH_CREATORS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
                singleSendId: { type: 'string' },
            },
            required: ['dropId'],
        },
    },
};
